/**
 * Class representing a digital asset loaded from Nitehawk.
 *
 * An asset is a class-based representation of data fetched from
 * a Nitehawk endpoint.  Although some assets are "nested" (in
 * a sense) through embedding, we treat these for now as separate
 * assets in and of themselves.  That is, an embed video contains
 * a media section similar to a video asset of the same media
 * ID, and thus in theory we could represent that inner media
 * object as a subasset.  But we keep things flat for now.
 */
export default class Asset {
  /**
   * Create a digital asset.
   *
   * @param {string} url - Nitehawk URL.
   * @param {Object} settings - Settings object.
   * @param {Object} defaultAttributes - Default attributes.
   */
  constructor(url, settings, defaultAttributes) {
    this.url = url;
    this.settings = settings;
    this.attributes = defaultAttributes;
  }

  /**
   * Load asset data via its Nitehawk URL.
   */
  load() {
    const url = [this.settings.nitehawkBaseUrl, this.url].join('/');
    return fetch(url)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return null;
      })
      .then(response => {
        if (response) {
          this.attributes = Object.assign(
            {},
            this.defaultAttributes,
            response,
          );
        }
        return this;
      })
      .catch(error => error);
  }
}
